import { wrapWithQoutes } from "../helperFuncs";

const fileNames = {
  7: "Per-ST-FSC-Template",
  8: "Flat-FSC-Template",
  40: "Per-Mile-FSC-Template",
};

export const GenerateFscTemplate = (templateParams) => {
  var dieselStart = Number(templateParams.diesel_start);
  var dieselSteps = Number(templateParams.diesel_steps);
  var dieselStepSize = Number(templateParams.diesel_step_size);
  var mileageSteps = Number(templateParams.mileage_steps);
  const fileName = fileNames[templateParams.method_id];

  try {
    const rows = [];
    var lo = 1;
    var hi = 10;

    if (templateParams.method_id === 40) {
      for (let i = 0; i < dieselSteps; i++) {
        let label;
        if (i === 0) {
          label = `$${dieselStart.toFixed(3)} - $${(dieselStart + dieselStepSize).toFixed(3)}`;
        } else {
          label = `$${(dieselStart + dieselStepSize * i + i / 1000).toFixed(3)} - $${(dieselStart + dieselStepSize * (i + 1) + (i) / 1000).toFixed(3)}`;
        }
        rows.push([label]);
      }
    } else {
      let dieselLabel = ["", ""];
      for (let i = 0; i < dieselSteps; i++) {
        let label;
        if (i === 0) {
          label = `$${dieselStart.toFixed(2)} - $${(dieselStart + dieselStepSize).toFixed(2)}`;
        } else {
          label = `$${(dieselStart + dieselStepSize * i + i / 100).toFixed(2)} - $${(dieselStart + (dieselStepSize * (i + 1) + i / 100)).toFixed(2)}`;
        }
        dieselLabel.push(label);
      }
      rows.push(dieselLabel);

      for (let j = 0; j < mileageSteps; j++) {
        rows.push([lo, hi]);
        lo = lo + 10;
        hi = hi + 10;
      }
    }

    const content = rows
      .map((row) => row.map(wrapWithQoutes).join(","))
      .join("\r\n");

    const blob = new Blob([content], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${fileName}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  } catch (err) {
    console.error(err);
  }
};